import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

const infrastructureConstants = {
    INFRASTRUCTURE_LOADED: 'INFRASTRUCTURE_LOADED'
};
export const infrastructureFulfilledConstants = getActionTypesResult(infrastructureConstants, '_FULFILLED');

export const fetchInfrastructure = createAsyncAction(infrastructureConstants.INFRASTRUCTURE_LOADED, () =>
    api.get('infrastructure').then(res => ({ osVersions: res.data.osVersions, screenSizes: res.data.screenSizes }))
);

export const setOStoInfrastructure = createAsyncAction(infrastructureConstants.INFRASTRUCTURE_LOADED, arrayOfOS =>
    Promise.resolve(arrayOfOS).then(osVersions => ({ osVersions }))
);

export const setLocationsToInfrastructure = createAsyncAction(
    infrastructureConstants.INFRASTRUCTURE_LOADED, () =>
        api.get(`Offices/trees`).then(res => ({ locations: [res.data] }))
);

export const setWhereaboutsToInfrastructure = createAsyncAction(
    infrastructureConstants.INFRASTRUCTURE_LOADED, () =>
        api.get(`locations/tree?locationLevel=2`).then(res => ({ whereabouts: [res.data] }))
);
